﻿import React from 'react';

export const List = (props) => {
  const wrappingClass = ['single-step__list', props.class].join(' ');

  return (
    <ul className={wrappingClass}>
      {
        props.rows.filter(row => row !== null).map((row, index) => {
          if (row.left) {
            return (
              <li key={index} className={row.class}>
                <div className="left">{row.left}</div>
                { !Array.isArray(row.right) && <div className="right">{row.right}</div> }
                { Array.isArray(row.right) && <div className="right column"><span className="strike">{row.right[0]}</span><span>{row.right[1]}</span></div> }
              </li>
            )
          }
        })
      }
    </ul>
  );
}